export default __webpack_public_path__ + "static/media/003-bumper car.251cf0a2.svg";